"use client";

import { useState } from "react";

import PlaceAutocomplete from "@/components/PlaceAutocomplete";
import type { PlaceResult } from "@/lib/api/misc";
import type { CityData } from "@/lib/cities-data.types";

interface TimingCityPickerProps {
  id: string;
  city: CityData;
  label: string;
  placeholder: string;
  help: string;
  onCityChange: (city: CityData) => void;
}

function cityFromPlace(place: PlaceResult): CityData {
  const region = place.display.split(",")[1]?.trim() || place.country || "India";
  return {
    slug: `${place.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${place.geoname_id}`,
    name: place.name,
    state: region,
    latitude: place.latitude,
    longitude: place.longitude,
    timezone: place.timezone || "Asia/Kolkata",
  };
}

export default function TimingCityPicker({
  id,
  city,
  label,
  placeholder,
  help,
  onCityChange,
}: TimingCityPickerProps) {
  const [value, setValue] = useState(city.name);

  function handleSelect(place: PlaceResult) {
    setValue(place.name);
    onCityChange(cityFromPlace(place));
  }

  return (
    <div className="card-sacred mb-5 p-4">
      <label htmlFor={id} className="mb-2 block text-body-small font-semibold text-ish-dark">
        {label}
      </label>
      <PlaceAutocomplete
        id={id}
        value={value}
        onChange={setValue}
        onSelect={handleSelect}
        placeholder={placeholder}
        required={false}
      />
      <p className="mt-2 text-caption text-ish-text-faint">{help}</p>
    </div>
  );
}
